import React from "react";

import styled from "styled-components/macro";

import { useCategoryCardContext } from "Dashboard/DashboardCards/DashboardCards";
import FnrTypography from "FnrTypography";

import FnrProgressBar from "UI/FnrProgressBar2";

const ProgressBar = () => {
  const { progressBarPercent, progressBarLabel } = useCategoryCardContext();

  if (!progressBarPercent || !progressBarLabel) return null;
  return (
    <StyledProgressBar>
      <FnrProgressBar
        count={Number(progressBarPercent)}
        max={100}
        delay={0.4}
      />
      <ProgressBarLabel>
        <FnrTypography type="copy" italic fontSize="xs">
          {progressBarLabel}
        </FnrTypography>
      </ProgressBarLabel>
    </StyledProgressBar>
  );
};

const StyledProgressBar = styled.div`
  position: relative;
`;

const ProgressBarLabel = styled.div`
  padding-top: 4px;
`;

export default ProgressBar;
